export default __webpack_public_path__ + "static/media/Celeste_Flare.c06c3efc.png";